import "./galaxy_evolves.css";
import brief from '../../assets/icons/brief.png';
import buy from '../../assets/icons/buy.png';
import duedeligence from '../../assets/icons/duedeligence.png';
import inspect from '../../assets/icons/inspect.png';
import negotiate from '../../assets/icons/negotiate.png';
import search from '../../assets/icons/search.png';
import settle from '../../assets/icons/settle.png';
import shortlist from '../../assets/icons/shortlist.png';
import support from '../../assets/icons/support.png';
import SectionName from "../section-name/section-name";
const GalaxyEvolves = () => {
    return (
        <div id="our-galaxy">
            <SectionName name="How our Galaxy Evolves"/>
            <div className="process-wrapper" >
                <div className="galaxybox" data-aos="zoom-in">
                    <div className="ge ge1">
                        <img src={brief} alt="" />
                        <b>Brief</b>
                    </div>
                    <div className="ge">
                        <img src={search} alt="" />
                        <b>Search</b>
                    </div> 
                    <div className="ge">
                        <img src={shortlist} alt="" />
                        <b>Shortlist</b>
                    </div>
                    <div className="ge">
                        <img src={duedeligence} alt="" />
                        <b>Due Deligence</b>
                    </div>
                    <div className="ge">
                        <img src={inspect} alt="" />
                        <b>Inspect</b>
                    </div>
                    <div className="ge">
                        <img src={negotiate} alt="" />
                        <b>Negotiate</b>
                    </div>
                    <div className="ge">
                        <img src={buy} alt="" />
                        <b>Buy</b>
                    </div>
                    <div className="ge">
                        <img src={settle} alt="" />
                        <b>Settle</b>
                    </div>
                    <div className="ge">
                        <img src={support} alt="" />
                        <b>Support</b>
                    </div>
                </div>
           </div>
        </div>
    );
};
export default GalaxyEvolves;
